<div [ngClass]="{'mobile': isMobile}" class="content">
  @if (!hideCustomerType) {
    <div>
      <div class="subtitle">
        <typography variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_paymentDetailsCustomerTypeLabel }}</typography>
      </div>
      <ds-radio-group id="customerTypeContainer" [ngClass]="isMobile ? 'radio-group-two-columns' : 'radio-group-simple'" groupTitle="" groupSubtitle=""
        orientation="horizontal" [values]="customerTypes" [control]="quoteOptionsForm.controls.customerType">
      </ds-radio-group>
    </div>
  }

  <div class="subtitle">
    <typography variant="mat-subtitle-2" weight="bold">{{ appStrings.quote_paymentDetailsSelectAttributes }} ({{ numberOfSelectedCheckboxes }})</typography>
  </div>

  <div class="attributes-container" id="attributesContainer">
    <ds-checkbox class="attribute" id="line_number" [label]="appStrings.label_lineNumber" [control]="quoteOptionsForm.controls.lineNumber"></ds-checkbox>
    @if (effectiveCountryCode !== 'DE') {
      <ds-checkbox class="attribute" id="line_sku" [label]="appStrings.products_gridOemSku" [control]="quoteOptionsForm.controls.oemSku"></ds-checkbox>
    }
    <ds-checkbox class="attribute" id="line_commCode" [label]="appStrings.label_communicationsCode" [control]="quoteOptionsForm.controls.commCode"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_coo" [label]="appStrings.label_coo" [control]="quoteOptionsForm.controls.countryOfOrigin"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_sin" [label]="appStrings.label_sinNumber" [control]="quoteOptionsForm.controls.sinNumber"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_listPrice" [label]="appStrings.products_gridListPrice" [control]="quoteOptionsForm.controls.listPrice"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_netPrice" [label]="appStrings.products_netPrice" [control]="quoteOptionsForm.controls.netPrice"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_grandTotal" [label]="appStrings.paymentDetails_summary_grand_total" [control]="quoteOptionsForm.controls.grandTotal"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_notes" [label]="appStrings.products_gridLineNotes" [control]="quoteOptionsForm.controls.lineNotes"></ds-checkbox>
    <ds-checkbox class="attribute" id="quote_notes" [label]="appStrings.quote_quoteNotes" [control]="quoteOptionsForm.controls.quoteNotes"></ds-checkbox>
    <ds-checkbox class="attribute" id="line_weight" [label]="appStrings.products_gridLineWeight" [control]="quoteOptionsForm.controls.lineWeight"></ds-checkbox>
    @if (effectiveCountryCode === 'GB') {
      <ds-checkbox class="attribute" id="quote_vat_uk" [label]="appStrings.label_vat" [control]="quoteOptionsForm.controls.vat"></ds-checkbox>
    }
    <ds-checkbox class="attribute" id="est_ship_date" [label]="appStrings.quote_estShipDate" [control]="quoteOptionsForm.controls.estimatedShipDate"></ds-checkbox>
  </div>
</div>
